import { hexToRgb } from "../../../../Utils/utils";

export const selectStyles = (hex, white) => {
  const { r, g, b } = hex ? hexToRgb(hex) : { r: 255, g: 255, b: 255 };
  return {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused
        ? `rgb(${r}, ${g}, ${b})`
        : provided.borderColor,
      "&:hover": {
        borderColor: state.isFocused
          ? `rgb(${r}, ${g}, ${b})`
          : provided.borderColor,
      },
      boxShadow: state.isFocused
        ? `0 0 0 1px rgb(${r}, ${g}, ${b})`
        : provided.boxShadow,
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: state.isSelected ? hex || "blue" : "white",
      color: state.isSelected ? (white ? "white" : "black") : "black",
      "&:hover": {
        backgroundColor: state.isSelected
          ? hex || "blue"
          : `rgba(${r},${g},${b}, 0.6)`,
        color: white ? "white" : "black",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 100,
    }),
  };
};

export const comparePortfolios = (originalMedia, currentMedia) => {
  const differences = [];

  // Iterate through each panel in the media array
  currentMedia.forEach((currentPanel, i) => {
    const originalPanel = originalMedia[i];

    if (!originalPanel) {
      // If the current portfolio has more panels than the original:
      // -> add all new uploads to the difference array for deletion
      differences.push(...currentPanel.uploads);
    } else {
      // Find uploads in current that are not in original
      const currentUploadsNotInOriginal = currentPanel.uploads.filter(
        (currentUpload) => {
          return !originalPanel.uploads.some(
            (originalUpload) =>
              originalUpload.mediaUrl === currentUpload.mediaUrl
          );
        }
      );

      // Combine the differences from both comparisons
      differences.push(...currentUploadsNotInOriginal);
    }
  });

  return differences;
};



// WEBPACK FOOTER //
// ./src/screens/ProductPortfolio/components/PortfolioModal/utils.js